import { Link, Navigate, useParams } from "react-router-dom";
import { CheckCircle2, Rocket } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";

export const FUNZIONI = {
  "fatturazione-elettronica": ["studio.jpg", "Fatturazione elettronica", "Programma per la fatturazione elettronica: fatture, note di credito, autofatture, clienti PA con split payment e XML FatturaPA controllato.",
    ["Tutti i tipi documento da TD01 a TD29, note di credito e fatture differite", "XML FatturaPA 1.2.2 controllato con lo schema ufficiale prima dell'invio",
      "Pubblica Amministrazione: codice IPA, CIG, CUP e split payment automatico", "Fatture ricevute, scadenzario, incassi e saldate con un clic", "PDF professionale con il tuo logo e invio al cliente via email"]],
  "magazzino-ddt": ["magazzino.jpg", "Magazzino, DDT e ordini", "Gestionale di magazzino online con DDT, preventivi, ordini clienti e fornitori, giacenze e codici a barre.",
    ["Articoli con giacenze, carichi, scarichi e inventario", "DDT con firma del cliente sul tablet e fattura differita TD24", "Preventivi che diventano ordine, fattura o DDT con un clic",
      "Ordini fornitori e proposta di riordino sotto scorta", "Lettura dei codici a barre con la fotocamera"]],
  "corrispettivi-cassa": ["cassa.jpg", "Corrispettivi e cassa", "Software corrispettivi e cassa per negozi: scontrini, chiusura giornaliera, registro corrispettivi e PDF.",
    ["Cassa a tutta pagina con tasti rapidi degli articoli pi\u00f9 venduti", "Pagamento contanti, carta o bonus con totale automatico", "Elenco completo degli scontrini con filtri e totali",
      "Chiusura giornaliera e registro dei corrispettivi in PDF", "Scontrino inviato al cliente via email"]],
  "agenti-di-vendita": ["agenti.jpg", "Agenti di vendita", "Software per agenti di vendita su tablet: clienti, catalogo, ordini, preventivi, incassi e provvigioni mensili.",
    ["App installabile su tablet Android e iPad", "Clienti, catalogo e giacenze sempre aggiornati", "Ordini e preventivi inviati al cliente via email",
      "Incassi della giornata con riepilogo PDF per l'ufficio", "Provvigioni mensili per agente con stampa del tabulato"]],
};

export default function Funzione() {
  const { slug } = useParams();
  const f = FUNZIONI[slug];
  useSeo(f ? f[1] : "Funzioni", f ? f[2] : "", `/funzioni/${slug}`);
  if (!f) return <Navigate to="/" replace />;
  const [img, title, desc, points] = f;
  return (
    <PublicLayout testid={`feature-page-${slug}`}>
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-sky-700">Funzioni</div>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">{title}</h1>
          <p className="mt-4 text-base text-slate-600">{desc}</p>
          <ul className="mt-8 space-y-3 text-sm text-slate-700">
            {points.map((p) => <li key={p} className="flex items-start gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />{p}</li>)}
          </ul>
          <Button asChild size="lg" className="mt-10 h-12 bg-blue-600 px-6 hover:bg-blue-700" data-testid="feature-trial-button"><Link to="/prova"><Rocket className="mr-2 h-4 w-4" />Prova gratis 30 giorni</Link></Button>
        </div>
        <img src={`/banners/${img}`} alt={title} className="aspect-[4/3] w-full rounded-2xl border border-slate-200 object-cover shadow-xl" />
      </div>
      <nav className="mt-16 flex flex-wrap gap-3 border-t border-slate-200 pt-8 text-sm" aria-label="Altre funzioni">
        {Object.entries(FUNZIONI).filter(([k]) => k !== slug).map(([k, v]) => (
          <Link key={k} to={`/funzioni/${k}`} data-testid={`feature-link-${k}`} className="rounded-full border border-sky-200 bg-white px-4 py-2 text-sky-800 hover:bg-sky-50">{v[1]}</Link>
        ))}
      </nav>
    </PublicLayout>
  );
}
